import React from "react";

import {Provider as ReduxProvider} from "react-redux";

import {getLocatorFromURL} from "@client/router";

import {Shell} from "@client/components/Shell";
import {App} from "@client/containers/App";
import {preloadSceneDependencies} from "@client/gotterdammerung";
import {Static} from "@client/shared/components/Static";
import {useSiteContext, useStaticURL} from "@client/site/context";
import {store} from "@client/store";
import {server} from "@reactivated";

const SSRContent = (props: {url: string; resolvedData: unknown}) => {
    const scenePath = getLocatorFromURL(props.url).locator?.scenePath;
    if (scenePath != null) {
        preloadSceneDependencies(scenePath, props.resolvedData);
    }
    return (
        <ReduxProvider store={store}>
            <App pathname={props.url} />
        </ReduxProvider>
    );
};

export const Template = (props: server.journal.templates.App) => {
    const STATIC_URL = useStaticURL();
    const siteContext = useSiteContext();

    return (
        <Shell>
            <Static />
            <meta charSet="UTF-8" />
            {props.ssr_resolved == null && (
                <title>{props.open_graph?.title ?? "Joy"}</title>
            )}
            <meta
                name="viewport"
                content="viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
            />
            {props.open_graph != null && (
                <>
                    <meta property="og:title" content={props.open_graph.title} />
                    <meta name="description" content={props.open_graph.description} />
                    <meta
                        property="og:description"
                        content={props.open_graph.description}
                    />
                    {props.open_graph.image.startsWith("http") ? (
                        <>
                            <meta
                                property="og:image"
                                content={props.open_graph.image}
                            />
                            <meta property="og:image:width" content="1200" />
                            <meta property="og:image:height" content="630" />
                        </>
                    ) : (
                        <meta
                            property="og:image"
                            content={`${STATIC_URL}${props.open_graph.image}`}
                        />
                    )}
                </>
            )}
            {props.is_capacitor === true ? (
                <>
                    <meta name="format-detection" content="telephone=no" />
                    <meta name="msapplication-tap-highlight" content="no" />

                    <meta name="theme-color" content="#31d53d" />
                </>
            ) : (
                <>
                    <link
                        rel="icon"
                        href={`${STATIC_URL}favicon.png`}
                        type="image/png"
                    />
                </>
            )}
            {import.meta.env.SSR && props.ssr_resolved != null && (
                <SSRContent
                    url={siteContext.request.url}
                    resolvedData={props.ssr_resolved}
                />
            )}
        </Shell>
    );
};
